//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectICurve.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../no/GeometricUtilities.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"Axis",1,"Axis",0],[1,"BaseArc",0,"SelectICurve",0],[1,"BaseDiameter",0,"Expression",0],[1,"BooleanOption",0,"GeometricUtilities.BooleanOperation",0],[1,"HalfAngle",0,"Expression",0],[1,"Height",0,"Expression",0],[0,"ParentAssociativity",1,0],[1,"TopArc",0,"SelectICurve",0],[1,"TopDiameter",0,"Expression",0],[0,"Type",1,0]],[],[]];
SPLM.Features.ConeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ConeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ConeBuilder.Types = Object.freeze({
    "DiametersAndHeight" : "DiametersAndHeight", "DiametersAndHalfAngle" : "DiametersAndHalfAngle", "BaseDiameterHeightAndHalfAngle" : "BaseDiameterHeightAndHalfAngle", "TopDiameterHeightAndHalfAngle" : "TopDiameterHeightAndHalfAngle", "TwoCoaxialArcs" : "TwoCoaxialArcs"});

export default SPLM;